<script lang="ts">
  import { push } from 'svelte-spa-router'
  import { api } from '../../../../../helpers'
  import { onMount } from 'svelte'
  import { addToast } from '../../../../custom/Toasts/store'

  import GeneralLayout from '../../../../layouts/GeneralLayout.svelte'
  import Button from '../../components/Button/Button.svelte'
  import DatePicker from '../../components/DatePicker/DatePicker.svelte'
  import TimePicker from '../../components/TimePicker/TimePicker.svelte'
  import SelectPostAction from './components/SelectPostAction.svelte'
  import Tooltip from '../../../../ui/Tooltip/Tooltip.svelte'

  export let params = {} as { id: string }

  $: uniqueEvents = new Set(events.map(e => e?.event?.pk))
  $: isNotDublicateEvents = uniqueEvents.size < events.length

  const postEvents = [
    { pk: 'activation', title: 'Опубликовать' },
    { pk: 'deactivation', title: 'Деактивировать' },
    { pk: 'pin', title: 'Закрепить пост' },
    { pk: 'unpin', title: 'Открепить пост' },
  ]

  let events = []

  const createEvent = () => {
    events.push({ event: null, date: '', time: '', pk: null })
    events = events
  }

  const generateScheduleBody = () => {
    return events.map(event => {
      const isCorrectDate = event.date !== '' && event.time !== ''

      return {
        pk: event?.pk,
        event: event?.event?.pk,
        event_date: isCorrectDate ? `${event?.date}T${event?.time}` : ''
      }
    })
  }

  const save = async () => {
    const body = generateScheduleBody()

    const isCorrectFillFields = body.filter((item) => {
      return item.event && item.event_date
    })

    if (isCorrectFillFields.length !== events.length) {
      addToast('Одно или несколько полей заполнены неверно')
      return 
    }

    const { ok } = await api(
      `/api/v1/publication-editor/schedule-item/sync/${params.id}/`,
      'POST',
      JSON.stringify(body),
      true
    )

    if (!ok) {
      addToast('Ошибка при создании расписания')
      return
    }

    addToast('Расписание успешно обновлено', 'success')
    push('/editor/list')
  }

  const getData = async () => {
    const response = await api (`/api/v1/publication-editor/schedule-item/list/${params.id}/`)
    return await response.json()
  }

  const createScheduleObject = ({ id: pk, event, event_date }) => {
    const date = new Date(event_date)

    return {
      pk,
      event: postEvents.find((e) => e.pk === event).pk,
      date: date.toLocaleDateString('sv-SE', {
        timeZone: 'Europe/Moscow'
      }),
      time: date.toLocaleTimeString('ru-RU', { 
        hour: '2-digit', 
        minute: '2-digit', 
        timeZone: 'Europe/Moscow' 
      })
    } 
  }

  const logError = (error) => {
    console.log(error)
  }

  const mapScheduleObject = (result) => {
    return result.map(createScheduleObject)
  }

  const getSchedules = () => {
    return getData()
      .then(mapScheduleObject)
      .catch(logError)
  }

  const deleteEvent = async (index: number) => {
    events.splice(index, 1)
    events = events
  }

  const setEvents = (result) => {
    events = result
  }

  const finalyGetSchedules = () => {
    events.length || createEvent()
  }
  

  onMount(() => {
    getSchedules()
      .then(setEvents)
      .catch(logError)
      .finally(finalyGetSchedules)
  })
</script>

<GeneralLayout isEditor>
  <div class="events-wrapper">
    <div class="back-button" on:click={() => push('/editor/list')}>
      <i class="icon-arrow-up" />
      <div class="text">Назад</div>
    </div>

    <div class="title-wrapper">
      <div class="title">Расписание</div>
      <Tooltip tooltip="Дата и время поста выставляется по московскому часовому поясу">
        <i class="icon-question" />
      </Tooltip>
    </div>

    {#if events.length}
      {#each events as item, index (index)}
        <div class="wrapper">
          <SelectPostAction bind:value={item.event} title="Действие с постом" items={postEvents} />
          <DatePicker bind:value={item.date} label="Дата" />
          <div>
            <TimePicker bind:value={item.time} label="Время" />
            <i class="icon-cross" on:click={() => deleteEvent(index)} />
          </div>
        </div>  

        {#if index !== events.length - 1}
          <hr>
        {/if}
      {/each}
    {/if}

    {#if events.length < 4}
      <div class="add-event" on:click={createEvent}>
        Добавить еще одно действие
      </div>
    {/if}

    {#if !isNotDublicateEvents}
      <Button label="Сохранить" on:click={save} />
    {/if}
  </div>
</GeneralLayout>

<style lang="scss">
  .title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    i {
      margin-left: 8px;
      color: #5A5F6D99;
      font-size: 18px;

      &::before {
        margin: 0;
      }
    }
  }

  .icon-cross {
    position: absolute;
    right: 0;
    font-size: 10px;
    cursor: pointer;
    top: 5px;
  }

  hr {
    margin: 8px 0 24px 0;
    border: 0.7px solid #D6DCFF;
  }

  .events-wrapper {
    margin-bottom: 188px;
  }

  .add-event {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    color: #5A5F6D;
    padding: 6px;
    width: 100%;
    border-radius: 30px;
    border: 1px solid #D6DCFF;
    margin-bottom: 24px;
    margin-top: 8px;
    box-sizing: border-box;
    cursor: pointer;
  }
  
  .wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
    align-items: center;
    position: relative;
  }

  .back-button {
    border-radius: 30px;
    padding: 6px 12px 6px 12px;
    font-weight: 600;
    line-height: 20px;
    color: #5A5F6D;
    border: 2px solid #E0E8F6;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    cursor: pointer;

    i {
      transform: rotate(-90deg);
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .title {
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    color: #30333D;
  }
</style>